/*
The MIT License (MIT)
Copyright (c) 2015 Aaron Rau

Permission is hereby granted, free of charge, to any person obtaining a copy of this software and associated documentation files (the "Software"), to deal in the Software without restriction, including without limitation the rights to use, copy, modify, merge, publish, distribute, sublicense, and/or sell copies of the Software, and to permit persons to whom the Software is furnished to do so, subject to the following conditions:
The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
*/
(function () {
  "use strict";

  var _doc = document;
  var _getElmById = function(id){
    return _doc.getElementById(id);
  }
  var _getElmByClass = function(className){
    return _doc.getElementsByClassName(className)
  };

  var PATHS = {},
      HOST = "",
      AUTH_PATH = "/auth/",
      SECTION_PATH = "/scripts/sections/",
      MODULE_PATH = "/scripts/modules/",
      LIB_PATH = "/scripts/libs/",
      CSS_PATH = "/css/"

  //private variables
  var _windowPosition = [],
      _backendProvider = null, //plat
      _popupStacks = [],
      _popupListener = null,
      _sectionParams = {},
      _currentSection = null,
      _sections = {},
      _modules ={};

  var _stateCursor = -1, // state management to wrap window.history
      _states = [],
      _stateListeners = [],
      _onWindowStateChange = null,
      _onStateChange = function(){

          for(var i = 0; i < _stateListeners.length; i++)
          {
            _stateListeners[i](_getCurrentState());
          }
      },
      _getCurrentState = function(){

        if(_states.length > _stateCursor && _stateCursor >= 0)
        {
          return _states[_stateCursor];
        }
        else
        {
          return null;
        }
      },
      _moveStateCursor = function(cnt){

        _stateCursor += cnt;

        //set bounds
        if(_stateCursor > _states.length)
        {
          _stateCursor = _states.length;  
        }
        else if(_stateCursor < -1)
        {
          _stateCursor = -1;
        }
        
      },
      isHttpProtocol = function(){
        
        if(document.location.protocol == 'http:' || document.location.protocol == 'https:')
          return true;
        else
          return false;
      };

  var _SectionNavButtons = {};
  var _SectionNavBadges = {};
  var _notificationElm = null;
  var _popover = null,
      _isInitPopovers = false;
  var _featureFlags = {};

  //private function
  var _loadSection = function(sName){


      if(IsEmpty(sName))
        return

      var container = _getElmById('scroll-content');

      var defaultPath = SECTION_PATH+sName+".js";

      if(_sectionParams[sName])
      if(_sectionParams[sName].host)
        defaultPath = _sectionParams[sName].host + SECTION_PATH+sName+".js";


      var titleArea = null;
      var hs = _getElmByClass('controls-header');
      if(hs)
      {
        if(hs.length > 0)
        {
          hs[0].className = 'controls-header '+ sName+'_header'
          var ht = hs[0].querySelector('#header_title');
          if(ht)
          {
            ht.innerHTML = '';
            var param = _sectionParams[sName];
            if(param)
              if(param.title)
              {
                ht.innerHTML = param.title;
                titleArea = ht;
              }
          }

        }
      }
      
      var buttonId = 'bt' + sName.toTitleCase();
      var badge = _SectionNavBadges[buttonId];


      var _renderSection = function(sName){

        require([SECTION_PATH+sName+".js"], function(section) {

            
            _sections[sName] = section;
            section.init(app.User.isLogin(),container,titleArea,badge);          
            section.render();

            _currentSection = _sections[sName];
        },function(err){
          //console.log(sName);
          console.log(err);
          _currentSection = null;
        }); 
        
      }



      if(!app.Mod(sName))
      {
        console.log('no modules found');
        LoadCSS(CSS_PATH+sName+'.css');
        app.RegMods([sName],function(){
            _renderSection(sName);
        })
      }
      else
      {
        _renderSection(sName);
      }



           
  }



  app.Ext(app, {
    //module registration
    Paths:function(paths){

      if(paths)
      {
        PATHS = paths;

        if(paths.section)
          SECTION_PATH = paths.section;
        
        if(paths.module)
          MODULE_PATH = paths.module;
        
        if(paths.css)
          CSS_PATH = paths.css;

        if(paths.lib)
          LIB_PATH = paths.lib;

        if(paths.auth)
          AUTH_PATH = paths.auth;

        if(paths.host)
        {
          HOST = paths.host;
          LIB_PATH = HOST+LIB_PATH;
          CSS_PATH = HOST+CSS_PATH;
          MODULE_PATH = HOST+MODULE_PATH;
          SECTION_PATH = HOST+SECTION_PATH;
        }        
      }
      
      var r = {
        auth:PATHS.auth ? PATHS.auth : AUTH_PATH,
        module:PATHS.module ? PATHS.module : MODULE_PATH,
        css:PATHS.css ? PATHS.css : CSS_PATH,
        lib:PATHS.lib ? PATHS.lib : LIB_PATH,
        section:PATHS.section ? PATHS.section : SECTION_PATH,
        host:PATHS.host ? PATHS.host : HOST
      }

      for(var p in PATHS)
      {
        if(!r[p])
          r[p] = PATHS[p];
      }

      return r;
    },
    Mod:function(sName)
    {
      return _modules[sName];
    },
    RegMod:function(name,mod)
    {
      if(_modules[name])
        return mod

      _modules[name] = mod;
    },
    RegMods:function(names,callback)
    {

      var paths = [];
      var moduleNames = names;
      for(var i = 0; i < moduleNames.length; i++)
      {
        var mName = moduleNames[i];
        if(!app.Mod(mName))
        {
          var defaultPath = MODULE_PATH+mName+".js";
          if(_sectionParams[mName])
          if(_sectionParams[mName].host)
            defaultPath = _sectionParams[mName].host + MODULE_PATH+mName+".js";

          paths.push(defaultPath);
        }          
      }

      if(paths.length > 0)
      {
        require(paths, function() {
         
          for(var i = 0; i < arguments.length; i++)
          {
            app.RegMod(moduleNames[i],arguments[i])
          }
          
          callback(paths);
        
        },function(err){
          console.log(err);
          callback(null);

        });
      }

    },
    Bind:function(module,componentsNames,objects)
    {
      /*
      @aaronrau: different name spaces and 2 deep name space are not supported right now such as 
        ["namespace_a.component","namespace_b.component","namespace_a.sub_namespace_a.component"]
      
      */

        for(var n in objects)
        {
          var i = parseInt(n);
          if(isNaN(i))
            continue;
          
          var uicomponent = objects[n];
          var paths = componentsNames[n].split('/');
          var names = paths[paths.length-1].split('.');
          var name = names[1].toTitleCase();
          var moduleName = names[0].toLowerCase();
          
          if(names[1] == 'DAL')
            name = 'DAL';

          //console.log(name);
          if(!app.Mod(moduleName) && names.length == 2)
            app.RegMod(moduleName,uicomponent);
          
          var ext = {}; ext[name] = uicomponent;
          app.Ext(module,ext);
        }

      


    },
    State:{ // manually handle state to allow for local access
      //https://developer.mozilla.org/en-US/docs/Web/Events/popstate
      init:function(value,opath){
        if(!_onWindowStateChange)
        {
          _onWindowStateChange = function(e){
            var state = e.state,
                type = e.type,
                target = e.target;

            if(_states.length > 0) //this should never have happened use app.State.push(); or call app.State.init()
            {
               //not sure where the cusor should be so check the state first;
               if(state)
               {
                  var isFound = false;
                  for(var i = 0; i < _states.length; i++)
                  {
                    var s = _states[i];
                    if(s.uid == state.uid)
                    {
                      _stateCursor = i;
                      isFound = true;
                      break;
                    }
                  }

                  if(!isFound)
                  {
                    console.warn("Invalid State. app.State.init() or app.State.push() may not have been called");
                  }
                  
               }
               else
               {
                  _stateCursor = 0;
               }
               _onStateChange();   
               
            }
            
          };
          window.addEventListener("popstate",_onWindowStateChange);
        }

        var v = null,
            p = null,
            urlParts = getURLParts(document.location),
            partsIdx = -1;

        var defaultSection = null;
        for(var s in _sectionParams)
        {
          defaultSection = s;
          break;
        }

        if(value){
          v = value;
        }
        else
        {
          var n1 = urlParts[0],
              n2 = "",
              nm = "";
          
          if(urlParts.length > 1)
          {
            n2 = urlParts[urlParts.length-1];
          }

          if(n2.indexOf('.') > -1) //most likely a local file reference;
          {
            
            nm = n2.split('.')[0].toLowerCase();
            if(nm.indexOf('index') > -1)
            {
                nm = defaultSection;
            }
          }
          else{

            //find first matching section with url name
            for(var i = 0; i < urlParts.length; i++)
            {
              var pt = urlParts[i].toLowerCase();
              if(_sectionParams[pt])
              {
                nm = pt;
                partsIdx = i;
                break;
              }    
            }

            if(IsEmpty(nm))
              nm = n1; 

            if(IsEmpty(nm))
              nm = defaultSection;
          }

          v = {
            section:nm
          }

          //opath = v.section + window.location.search + window.location.hash;
        }

        if(!IsEmpty(opath)){
          p = opath;
        }
        else
        {
          var splitparts = "";
          if(partsIdx > -1)
          {
            splitparts = ''
            for(var i = partsIdx+1; i < urlParts.length; i++)
            {
              var p = urlParts[i];
              splitparts += ('/'+p);
            }
          }
          p = '/'+v.section+splitparts+ window.location.search + window.location.hash;
        }

        _stateCursor = -1;
        app.State.push(v,p);
      },
      back:function(){
        
        if(isHttpProtocol()){
          window.history.back();
        }
        else
        {
          _moveStateCursor(-1);
          _onStateChange();
        }
      },
      forward:function(){
        
      
        if(isHttpProtocol()){
          window.history.forward();
        }
        else
        {
          _moveStateCursor(1);
          _onStateChange();
        }
      },
      go:function(cnt){
       
        if(isHttpProtocol()){
          window.history.go(cnt);
        }
        else
        {
          _moveStateCursor(cnt);
          _onStateChange();
        }
      },
      push:function(value,path){
        
        var s = {
          value:value,
          path:path,
          uid:guidGenerator()
        }

        _moveStateCursor(1);
        _states[_stateCursor] = s;

        if(isHttpProtocol()){
          window.history.pushState(_states[_stateCursor], "", path);
        }

      },
      replace:function(value,path){
        if(_stateCursor < 0)
          _stateCursor = 0;

        var s = {
          value:value,
          path:path,
          uid:guidGenerator()
        }

        _states[_stateCursor] = s;

        if(isHttpProtocol()){
          window.history.replaceState( _states[_stateCursor], "", path);
        }

      },
      get:function(){
        return _states;
      },
      value:function(){
        return _getCurrentState().value;
      },
      current:function(){
        return _getCurrentState();
      },
      addEventListener:function(func){
       
        if(!_stateListeners)
        {
          _stateListeners = [];
        }

        _stateListeners.push(func); //type & value & current state are passed;
      }
    },
    User:{
      get:function()
      {
        return _backendProvider.User.current();
      },
      become:function(token,error){

        if(IsEmpty(error))
        {

          _backendProvider.User.become(token).then(function(result){
            
            var currentUser = _backendProvider.User.current();
            onLoginSuccess(currentUser);
            
          });

        }
        else
        {
          alert(error);
          //document.getElementsByClassName('')
        }

      },
      isLogin:function()
      {
        var currentUser = null;
        if(_backendProvider)
          currentUser = _backendProvider.User.current(); 
         
        return currentUser ? currentUser : false;
      },
      login:function(callback){
        //todo
      },
      logout:function(callback){


        app.DAL.logout();

        setTimeout(function() {
          if(callback)
            callback();
          else
            location.reload();
        }, 800);

      }
    },
    Controller: {
      sectionBadges:null,
      checkFeature:function(feature_flag)
      {
        return _featureFlags[feature_flag];
      },
      setFeatureFlags:function(flags)
      {
        _featureFlags = flags;
      },
      setBackendProvider:function(provider){
        _backendProvider = provider;
      },
      getBackendProvider:function(){
        return _backendProvider;
      },
      lockWindow: function() {
        _windowPosition = [
          self.pageXOffset || document.documentElement.scrollLeft || document.body.scrollLeft,
          self.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop
        ];
        var html = document.getElementsByTagName('html')[0]; // it would make more sense to apply this to body, but IE7 won't have that
        html.data = {};
        html.data['scroll-position'] = _windowPosition;
        html.data['previous-overflow'] =  html.style.overflow;
        html.style.overflow = 'hidden';
        window.scrollTo(_windowPosition[0], _windowPosition[1]);
      },
      unlockWindow: function() {
        // un-lock scroll position
        var html = document.getElementsByTagName('html')[0];

        if(html.data)
        {
          var scrollPosition = html.data['scroll-position'];
          html.style.overflow = html.data['previous-overflow'];
          window.scrollTo(scrollPosition[0], scrollPosition[1]);
   
        }
      },
      clearNotification:function(){
        var nt = document.getElementById('notification');
        if(nt)
        {
          if(_notificationElm)
          {
            nt.removeChild(_notificationElm);
            _notificationElm = null;
          }
          else
          {
            nt.innerHTML = "";
          }
        }
      },
      setNotification:function(elm)
      {
        var nt = document.getElementById('notification');
        if(nt)
        {

          if(_notificationElm)
          {
            nt.removeChild(_notificationElm);
            _notificationElm = null;
          }
          else
          {
            nt.innerHTML = "";
          }

          if(typeof elm == 'string')
          {
             nt.innerHTML = elm;
          }
          else if (typeof elm == 'object')
          {
            _notificationElm = elm;
            nt.addELM(elm)
          }
        }
      },
      showPopover:function(obj,type){

        var pc = null;
        if(type == 'scroll')
        {
          if(!_popover)
            _popover = obj;

          pc = _popover.getControls();

          //if(pc.style.display == 'block')
          //  pc.style.display = 'none'
          //return;
        }
        else if(type == 'resize') //window is resizing
        {
          if(!_popover)
            _popover = obj;

          pc = _popover.getControls();

        }
        else
        {
          if(!_popover)
          {
            _popover = obj;
          }

          var opc =  _popover.getControls();
          var p = opc.parentNode;
          if(p)
            p.removeChild(opc);
          
           _popover = obj;
          
          pc = _popover.getControls();
          document.body.appendChild(pc);          
        }


        var rec = _popover.getELM().getBoundingClientRect(),
            prec = pc.getBoundingClientRect(),
            offset = 0;

        var prm = _popover.getParams();
        if(prm.mode)
          if(prm.mode == "global")
          {
            var height = window.innerHeight
                      || document.documentElement.clientHeight
                      || document.body.clientHeight;
            
            if(!prm.disableAutoPlacement){
              if((rec.top + prec.height + 50) > height)
              {
                pc.style.top = (pc.style.top - rec.height);
                offset = -1*(prec.height+40);
                if(pc.className.indexOf(' loc-above') == -1)
                    pc.className = pc.className + ' loc-above';
              }
              else
              {
                pc.className = pc.className.replace(' loc-above',''); 
              }              
            }
          }

        pc.style.top = (rec.top+offset+window.scrollY)+"px";
        pc.style.left = (rec.left+window.scrollX)+"px";

        pc.style.display = 'block';

      },
      handleExpandEvent:function(type,event)
      {
        for(var i = 0; i < app.controls.expandButtons.length; i++)
        {
          if(app.controls.expandButtons[i].handle)
            app.controls.expandButtons[i].handle(type,event);
        }
      },
      registerExpand:function(obj){

          if(!app.controls.expandButtons)
          {
             app.controls.expandButtons = [] 
          }

          if(!_isInitPopovers)
          {
            _isInitPopovers = true;

            document.body.addEventListener("mousedown", function(e) {
              app.Controller.handleExpandEvent('document-mousedown',e);
            });
            //is shown with app.Controller.showPopover
            window.addEventListener("resize", function(event) {
              app.Controller.handleExpandEvent('window-resize',event);
            });
            
            //is shown with app.Controller.showPopover
            window.addEventListener("scroll", function(event) {
              app.Controller.handleExpandEvent('window-scroll',event);
            },true); 

          }

          app.controls.expandButtons.push(obj.getControls());

      },
      getVisiblePopover:function(){

        if(app.controls.expandButtons)
          for(var i = 0; i < app.controls.expandButtons.length; i++)
          {
            var item = app.controls.expandButtons[i];
   
              if(item.style.display == 'block')
              {
                return item;        
              }
          }

        return null;        
      },
      closePopovers:function(e)
      {
        if(app.controls.expandButtons)
        for(var i = 0; i < app.controls.expandButtons.length; i++)
        {
          var item = app.controls.expandButtons[i];
          if(item.handle)
          {
            item.handle('close-popover',e);
          }
          else
          {
            if(item.style.display != 'none')
              item.style.display = 'none';            
          }

        }
      },
      pushPopup:function(popup,path,hasState)
      {
        var p = path;
        app.Controller.closePopovers();

       
        if(hasState)
        {
          return hasState;
        }

        _popupStacks.push(popup);

        if(IsEmpty(p))
        {
          p = app.State.current().path;
        }
    
        app.State.push({"objectHash":guidGenerator(),isPopup:true},p);
       
        if(!_popupListener)
        {
          _popupListener = function(currentState){ // AR: This state is the state before the pushed popup

              var p = _popupStacks.pop();
              if(p)
              {
                p.hide();
              }   

          };
          app.State.addEventListener(_popupListener);
        }
        
        return app.State.value();

        
      },
      popPopup:function()
      {
        app.State.back();
      },
      //TODO: http://spoiledmilk.com/blog/html5-changing-the-browser-url-without-refreshing-page/
      initSectionSelections: function(sectionNames) {

        window.onscroll = function(e)
        { 
          app.Controller.closePopovers(e);
        }

        _sectionParams = sectionNames;
        _sections = {};

        var fs = _getElmByClass('controls-footer');
        var footer = null;
        if(fs)
          footer = fs[0];
        
        if(footer)
        {
          footer.innerHTML = '';
          var ul = cELM('ul');
          footer.addELM(ul);

          //console.log(sectionNames);
          //build footer controls
          for (var section in _sectionParams) {
          
            _sections[section] = null;

            var buttonId = 'bt' + section.toTitleCase();

            var w = cELM('li');
            var anc = cELM('a');
            var bt = cELM('div','button '+buttonId);
            anc.addELM(bt);
            anc.value = buttonId;
            anc.section = section;
            anc.onclick = function(e) {
                

              
                app.Controller.showSection(this.section);
              }

            w.addELM(anc);
            
            if(_sectionParams[section].hasBadge)
            {
              var badge = cELM('div','badge badge'+section.toTitleCase());
              anc.addELM(badge);
              _SectionNavBadges[buttonId] = badge;

              if(_CTRL().sectionBadges)
              {
                  if(_CTRL().sectionBadges[section])
                    badge.innerHTML = _CTRL().sectionBadges[section];
              }
            }

            ul.addELM(w);

            _SectionNavButtons[buttonId] = bt;


          }
        }
       
      },
      showSection: function(initSectionName) {
        
        var loc = document.location.toString();
        if(loc.indexOf('/auth/') >-1 ||
          loc.indexOf('/login') >-1 ||
          loc.indexOf('/logout') >-1 ||
          loc.toString().indexOf('/signup') >-1)
          return;

        var sName = "";

        if(initSectionName)
        {
          sName = initSectionName;
          app.State.push({section:sName},sName);
        }
        else
        {
          app.State.init();
          var st = app.State.value();
          sName = st.section;
        }

        var csec = _currentSection;
        if(csec)
          if(csec.clear)
            csec.clear();

        //select current button
        for(var bId in _SectionNavButtons)
        {
          var bt = _SectionNavButtons[bId];
          bt.className = 'button ' + bId;
        }


        var bId = 'bt' + sName.toTitleCase();
        if (_SectionNavButtons[bId]) {
          var bt = _SectionNavButtons[bId];
          if (bt) {
            bt.className = 'button ' + bId + "-selected";
          }
        }

        var hs = _getElmByClass('controls-header');
        if(hs)
        {
          if(hs.length > 0)
          {
            hs[0].className = 'controls-header '+ sName+'_header'
            var ht = hs[0].querySelector('#header_title');
            if(ht)
            {
              ht.innerHTML = '';
              var param = _sectionParams[sName];
              if(param)
                if(param.title)
                {
                  ht.innerHTML = param.title;
                }
            }

          }
        }

        var sec = _sections[sName];
        if (sec) {
          sec.render();
          _currentSection = _sections[sName];

        }
        else
        {
          var param = _sectionParams[sName];

          if(param)
          if(param.mods)
          if(param.mods.length > 0)
            return app.RegMods(param.mods,function(){
              if(param.css)
                LoadCSS(param.css);
              //load section from JS TODO: might have to add a loading sign if this is too slow;
              _loadSection(sName);
            })
          

          return _loadSection(sName);
          
        }




      }
    }

  });

}());
